"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _constant = require("./constant");
var _DefaultSavedCard = _interopRequireDefault(require("./DefaultSavedCard.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */

var DefaultSavedCardWrapper = _styledComponents.default.div.withConfig({
  displayName: "DefaultSavedCard__DefaultSavedCardWrapper",
  componentId: "sc-y5txqz-0"
})(["display:", ";"], function (_ref) {
  var theme = _ref.theme,
    isMobile = _ref.isMobile;
  return !isMobile ? '' : 'flex';
});
DefaultSavedCardWrapper.displayName = 'DefaultSavedCardWrapper';
var CardInfoContainer = _styledComponents.default.div.withConfig({
  displayName: "DefaultSavedCard__CardInfoContainer",
  componentId: "sc-y5txqz-1"
})(["width:", ";font-size:", ";"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '50%' : '';
}, function (_ref3) {
  var theme = _ref3.theme,
    isMobile = _ref3.isMobile;
  return !isMobile ? theme.fontSize.normal : theme.fontSize.small;
});
var CardLinkContainer = _styledComponents.default.div.withConfig({
  displayName: "DefaultSavedCard__CardLinkContainer",
  componentId: "sc-y5txqz-2"
})(["width:", ";font-size:", ";position:relative;@media ", "{text-align:", ";padding-right:", ";}"], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? '50%' : '';
}, function (_ref5) {
  var theme = _ref5.theme,
    isMobile = _ref5.isMobile;
  return !isMobile ? theme.fontSize.normal : theme.fontSize.small;
}, _constant.DEVICE.laptop, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? 'right' : '';
}, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? '10px' : '';
});
var CardTypeContainer = _styledComponents.default.span.withConfig({
  displayName: "DefaultSavedCard__CardTypeContainer",
  componentId: "sc-y5txqz-3"
})(["color:#4c4c50;font-family:", ";font-weight:", ";line-height:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontFamily.default;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeight.normal;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight.XLarge;
});
var CardLogoContainer = _styledComponents.default.span.withConfig({
  displayName: "DefaultSavedCard__CardLogoContainer",
  componentId: "sc-y5txqz-4"
})(["margin-right:10px;width:25px;height:25px;display:inline-block;"]);
var CardLogo = _styledComponents.default.img.withConfig({
  displayName: "DefaultSavedCard__CardLogo",
  componentId: "sc-y5txqz-5"
})(["max-height:100%;max-width:100%;"]);
var ChangePaymentLink = _styledComponents.default.a.withConfig({
  displayName: "DefaultSavedCard__ChangePaymentLink",
  componentId: "sc-y5txqz-6"
})(["text-decoration:none;margin-right:5px;font-family:", ";color:", ";font-weight:", ";line-height:", ";cursor:pointer;display:inline;"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily.default;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.type === 'AIRASIA_MOVE' ? theme.colors.tertiaryRed : theme.colors.secondary;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontWeight.normal;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.lineHeight.XLarge;
});
ChangePaymentLink.displayName = 'ChangePaymentLink';
var ToolTipContainer = _styledComponents.default.span.withConfig({
  displayName: "DefaultSavedCard__ToolTipContainer",
  componentId: "sc-y5txqz-7"
})(["position:absolute;cursor:pointer;top:2px;@media ", "{right:", ";transform:", ";}@media ", "{right:", ";transform:", ";}"], _constant.DEVICE.mobileM, function (_ref15) {
  var isMobile = _ref15.isMobile;
  return isMobile ? '0' : '';
}, function (_ref16) {
  var isMobile = _ref16.isMobile;
  return isMobile ? 'perspective(1px) translateY(-50%)' : '';
}, _constant.DEVICE.mobileS, function (_ref17) {
  var isMobile = _ref17.isMobile;
  return isMobile ? '-10px' : '';
}, function (_ref18) {
  var isMobile = _ref18.isMobile;
  return isMobile ? 'perspective(1px) translateY(-50%)' : '';
});
ToolTipContainer.displayName = 'ToolTipContainer';
var ModalSection = function ModalSection(theme, openModal, translation, closeModalHandler, accessible) {
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: "AIRASIA_CLASSIC"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    openModal: openModal,
    width: _constant.MODAL_DEFAULT_WIDTH,
    onClose: closeModalHandler,
    accessible: accessible
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    theme: theme,
    bold: true,
    type: "default",
    accessible: accessible
  }, translation.title), /*#__PURE__*/_react.default.createElement(_Text.default, {
    theme: theme,
    accessible: accessible
  }, translation.description)));
};
var DefaultSavedCard = function DefaultSavedCard(props) {
  var theme = props.theme,
    accessible = props.accessible,
    data = props.data,
    translations = props.translations,
    onClickChangePayment = props.onClickChangePayment,
    isMobile = props.isMobile;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    openModal = _useState2[0],
    setOpenModal = _useState2[1];
  var locale = data.locale;
  var translationList = translations;
  if (!translationList) {
    console.error('DefaultSavedCard --- No translation provided using default');
    translationList = _constant.TRANSLATION_DEFAULT;
  }
  var selectedTranslations = translationList[locale];
  if (!selectedTranslations) {
    selectedTranslations = translationList[_constant.DEFAULT_LOCALE];
  }
  var tabIndex = !accessible ? '-1' : '0';
  var modalTranslationData = selectedTranslations.modal;
  var _selectedTranslations = selectedTranslations,
    paymentMethodLabel = _selectedTranslations.paymentMethodLabel;
  var cardNameDisplay = _constant.CARD_TEXT_DISPLAY[data.cardType] || _constant.CARD_TEXT_DISPLAY.MC;
  // replaces the X from API with asterisk (*)
  var cardMaskedNumber = data.cardNumber.replace(/X/g, '*');
  var clickHandlerTooltip = function clickHandlerTooltip() {
    if (isMobile) return;
    setOpenModal(!openModal);
  };
  var clickChangePaymentHandler = function clickChangePaymentHandler() {
    onClickChangePayment(true);
  };
  var closeModalHandler = function closeModalHandler() {
    setOpenModal(!openModal);
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, ModalSection(theme, openModal, modalTranslationData, closeModalHandler, accessible), /*#__PURE__*/_react.default.createElement(DefaultSavedCardWrapper, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(CardInfoContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(CardLogoContainer, null, /*#__PURE__*/_react.default.createElement(CardLogo, {
    src: data.cardLogo
  })), /*#__PURE__*/_react.default.createElement(CardTypeContainer, {
    tabIndex: tabIndex
  }, cardNameDisplay, " ", cardMaskedNumber)), /*#__PURE__*/_react.default.createElement(CardLinkContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(ChangePaymentLink, {
    onClick: clickChangePaymentHandler,
    tabIndex: tabIndex
  }, paymentMethodLabel), /*#__PURE__*/_react.default.createElement(ToolTipContainer, {
    onClick: clickHandlerTooltip,
    tabIndex: tabIndex,
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant.ICON_INFO.color,
    fontsize: _constant.ICON_INFO.fontSize,
    icon: isMobile ? _constant.ICON_INFO.mobileIcon : _constant.ICON_INFO.desktopIcon
  })))));
};
DefaultSavedCard.propTypes = _DefaultSavedCard.default.PropTypes;
DefaultSavedCard.defaultProps = _DefaultSavedCard.default.DefaultProps;
var _default = DefaultSavedCard;
exports.default = _default;